import { z } from "zod";

/** Stellar public key: 56 chars, starts with G, base32 */
const stellarKeyRegex = /^G[A-Z2-7]{55}$/;

export const productionWhitelistSchema = z
	.object({
		custodialType: z.enum(["Custodial", "Non-Custodial", "Both"]),
		tomlFileDomain: z.string().optional(),
		homeDomain: z.string().optional(),
		fundingAddress: z.string().optional(),
		depositAddress: z.string().optional(),
		authAddress: z.string().optional(),
		excludedCountries: z.array(z.string()),
	})
	.superRefine((data, ctx) => {
		const isCustodial =
			data.custodialType === "Custodial" || data.custodialType === "Both";
		const isNonCustodial =
			data.custodialType === "Non-Custodial" || data.custodialType === "Both";

		if (isNonCustodial && !data.tomlFileDomain?.trim()) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: "TOML File Domain is required for Non-Custodial wallets",
				path: ["tomlFileDomain"],
			});
		}

		if (isCustodial) {
			if (!data.homeDomain?.trim()) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: "Home Domain is required for Custodial wallets",
					path: ["homeDomain"],
				});
			}
			if (!data.fundingAddress?.trim()) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: "Funding Address is required for Custodial wallets",
					path: ["fundingAddress"],
				});
			} else if (!stellarKeyRegex.test(data.fundingAddress.trim())) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message:
						"Must be a valid Stellar public key (G followed by 55 characters)",
					path: ["fundingAddress"],
				});
			}
			if (!data.depositAddress?.trim()) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: "Deposit Address is required for Custodial wallets",
					path: ["depositAddress"],
				});
			}
			if (!data.authAddress?.trim()) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: "Authentication Address is required for Custodial wallets",
					path: ["authAddress"],
				});
			}
		}
	});

export type ProductionWhitelistFormData = z.infer<
	typeof productionWhitelistSchema
>;
